// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { invalidFieldContainerStyles } from '../../common/questionWrappers';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var RichTextEditorWrapper = styled.div(function (props) {
  return props.isInvalid && invalidFieldContainerStyles;
});